module.exports = __webpack_public_path__ + "public/Icons/service-provider-chat-icon.png?d666b9e7";